// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

function ChatSvg() {
    return (
        <svg
            width='125'
            height='97'
            viewBox='0 0 125 97'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                opacity='0.08'
                width='50'
                height='50'
                rx='2'
                fill='var(--button-bg)'
            />
            <rect
                opacity='0.12'
                x='30'
                y='50'
                width='95'
                height='28'
                rx='2'
                fill='var(--button-bg)'
            />
            <circle
                cx='95.5'
                cy='32.5'
                r='2.5'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <circle
                cx='109'
                cy='32.5'
                r='2.5'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <circle
                cx='122.5'
                cy='32.5'
                r='2.5'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <path
                d='M95.0443 87.1199L105 97V46C105 44.8954 104.105 44 103 44H55C53.8954 44 53 44.8954 53 46V84.5395C53 85.644 53.8954 86.5395 55 86.5395H93.6355C94.1633 86.5395 94.6697 86.7481 95.0443 87.1199Z'
                fill='var(--indigo-400)'
            />
            <path
                d='M67 65H97'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <path
                d='M67 72H86'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <path
                d='M67 59H77'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <path
                d='M80 59H93'
                stroke='var(--center-channel-bg)'
                strokeLinecap='round'
            />
            <path
                d='M27.605 69.5638L14 83V14C14 12.8954 14.8954 12 16 12H82C83.1046 12 84 12.8954 84 14V66.9868C84 68.0914 83.1046 68.9868 82 68.9868H29.0103C28.4842 68.9868 27.9793 69.1941 27.605 69.5638Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M16 12.5H82C82.8284 12.5 83.5 13.1716 83.5 14V66.9873C83.4998 67.8155 82.8283 68.4873 82 68.4873H29.0107C28.3532 68.4873 27.7218 68.746 27.2539 69.208L14.5 81.8027V14C14.5 13.1716 15.1716 12.5 16 12.5Z'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
            />
            <circle
                cx='32'
                cy='31'
                r='9'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M47 27H63'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M24 51H74'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M24 58H46'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M47 33H72'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M24 45H41'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M45 45H63'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.48'
                strokeLinecap='round'
            />
            <path
                d='M9 39.5L9 58L19.5 58'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9 36.5L9 30.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9 27.5L9 25.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}

export default ChatSvg;
